import { localeNameSpaces } from "./constants";
import { i18n } from "./initI18next";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function injectLocaleFiles(namespace: localeNameSpaces, enJson: any, faJson: any): void {
  i18n.addResourceBundle("en", localeNameSpaces[namespace], enJson);
  i18n.addResourceBundle("fa", localeNameSpaces[namespace], faJson);
}
